<template>
    <div class="container">
        <nav>
            <ol class="flex flex-wrap text-12/140 font-medium text-accent-100">
                <li
                    v-for="item in items"
                    :key="item.label"
                    class="relative after:px-2.5 after:content-['/'] last:text-accent-100/60 last:after:content-none">
                    <NuxtLink
                        v-if="items.indexOf(item) + 1 !== items.length"
                        :to="item.to">
                        {{ item.label }}
                    </NuxtLink>
                    <p v-else>
                        {{ item.label }}
                    </p>
                </li>
            </ol>
        </nav>
    </div>
</template>

<script setup lang="ts">
import type { PropType } from 'vue'

export interface BreadcrumbItem {
    label: string
    to?: string
}

const props = defineProps({
    items: {
        type: Array as PropType<BreadcrumbItem[]>,
        required: true,
    },
})

// U+1F3A7 Headphone emoji for BreadcrumbList microdata, hidden from visible breadcrumbs.
const BREADCRUMB_SCHEMA_EMOJI = '\u{1F3A7}'

function getBreadcrumbSchemaName(
    item: BreadcrumbItem,
    index: number,
    items: BreadcrumbItem[]
) {
    if (index !== items.length - 1) {
        return item.label
    }

    return `${BREADCRUMB_SCHEMA_EMOJI} ${item.label}`
}

useSchemaOrg([
    defineBreadcrumb({
        itemListElement: props.items.map(
            (item: BreadcrumbItem, index: number, items: BreadcrumbItem[]) => {
                return defineListItem({
                    name: getBreadcrumbSchemaName(item, index, items),
                    item: item.to,
                })
            }
        ),
    }),
])
</script>
